import React from "react";
import { Images } from "../Common/Images.jsx";
import { useTranslation } from "react-i18next";

export default function SuccessPopupModal({ title, message, onClose }) {
  const { t } = useTranslation("common");

  return (
    <div
      className="modal successpopup successpopup-backdrop show d-block"
      id="confirmModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered modal-custom-width">
        <div className="modal-content modal-radius">
          <div className="modal-body">
            
            {/* Close Icon */}
            <div className="close-modal" onClick={onClose}>
              <img src={Images.Close} alt="Close" />
            </div>

            {/* Title */}
            <div className="pt-2">
              <h5 className="popup-title">{title}</h5>
            </div>

            {/* Description */}
            <div className="modal-des mt-35">
              <p>{message}</p>

              {/* Success Image */}
              <div className="modal-img text-center">
                <img
                  src={Images.ConfirmIcon}   // make sure you have this in Images.jsx
                  className="img-fluid"
                  alt="Success"
                />
              </div>

              {/* Confirm Button */}
              <button
                className="main-btn outline-green-btn w-full"
                onClick={onClose}
                type="button"
              >
                {t("confirm")}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
